/**
 * Maturity Levels feature hooks — React Query wrappers for CRUD operations.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { maturityLevelsApi } from './api'

export function useEngineMaturityLevels() {
    return useQuery({
        queryKey: ['maturity-levels'],
        queryFn: async () => {
            const res = await maturityLevelsApi.getAll()
            return res.data
        },
    })
}

export function useCreateEngineMaturityLevel() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (data: any) => maturityLevelsApi.create(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['maturity-levels'] })
        },
    })
}

export function useUpdateEngineMaturityLevel() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({ level, data }: { level: number; data: any }) =>
            maturityLevelsApi.update(level, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['maturity-levels'] })
        },
    })
}

export function useDeleteEngineMaturityLevel() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (level: number) => maturityLevelsApi.delete(level),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['maturity-levels'] })
        },
    })
}

